// extracted by mini-css-extract-plugin
export default {"Game":"GameItem_Game__AHNWf","Loto":"GameItem_Loto__4IVV0","Digit1":"GameItem_Digit1__EHNCd","Digit2":"GameItem_Digit2__-2mwP","LotoFlag":"GameItem_LotoFlag__r6v4q"};